/** The statistics from the server (GET /api/stats) and whether they are on their way. */
import type { StatsResponse } from '@cube-rush/shared';
import { batch, type ReadonlySignal, type Signal, signal } from '@preact/signals';
import type { StatsFailure } from '../net/api';

export type StatsStatus = 'idle' | 'loading' | 'ready' | 'failed';

export class StatsStore {
  private readonly statusSignal: Signal<StatsStatus> = signal('idle');
  private readonly dataSignal: Signal<StatsResponse | null> = signal(null);
  private readonly errorSignal: Signal<StatsFailure | null> = signal(null);

  readonly status: ReadonlySignal<StatsStatus> = this.statusSignal;
  /** The latest statistics (kept while new ones load, so the screen never goes blank). */
  readonly data: ReadonlySignal<StatsResponse | null> = this.dataSignal;
  readonly error: ReadonlySignal<StatsFailure | null> = this.errorSignal;

  loading(): void {
    this.statusSignal.value = 'loading';
  }

  loaded(stats: StatsResponse): void {
    batch(() => {
      this.dataSignal.value = stats;
      this.errorSignal.value = null;
      this.statusSignal.value = 'ready';
    });
  }

  failed(error: StatsFailure): void {
    batch(() => {
      this.errorSignal.value = error;
      this.statusSignal.value = 'failed';
    });
  }

  clear(): void {
    batch(() => {
      this.dataSignal.value = null;
      this.errorSignal.value = null;
      this.statusSignal.value = 'idle';
    });
  }
}
